

export const runsForPortfolio = (runs, portfolioId) => Object.values(runs || {})
  .filter(it => it.portfolioId === portfolioId && it.status === 'Running')

